"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cloneFromTemplateArtifact = void 0;
const uuid_1 = require("uuid");
const cloneUtils_1 = require("../cloneUtils");
const node_1 = require("./node");
const cloneConfig = ({ config, cloneMap, }) => {
    const { borrowingBaseReportLpSlugArtifactSlug, generatedCashBalanceFeedArtifactSlug, eligibilityTestArtifactSlug, concentrationLimitKickoutArtifactSlug, multiLoanProductConcentrationKickoutLpSlugArtifactSlug, classDetailsArtifactSlug, fundingSubmissionComponentsArtifactSlug, cashResponseTapeArtifactSlug, } = config;
    return {
        borrowingBaseReportLpSlugArtifactSlug: (0, cloneUtils_1.getClonedArtifactSlug)(borrowingBaseReportLpSlugArtifactSlug, cloneMap),
        generatedCashBalanceFeedArtifactSlug: (0, cloneUtils_1.getClonedArtifactSlug)(generatedCashBalanceFeedArtifactSlug, cloneMap),
        eligibilityTestArtifactSlug: (0, cloneUtils_1.getClonedArtifactSlug)(eligibilityTestArtifactSlug, cloneMap),
        concentrationLimitKickoutArtifactSlug: (0, cloneUtils_1.getClonedArtifactSlug)(concentrationLimitKickoutArtifactSlug, cloneMap),
        multiLoanProductConcentrationKickoutLpSlugArtifactSlug: (0, cloneUtils_1.getClonedArtifactSlug)(multiLoanProductConcentrationKickoutLpSlugArtifactSlug, cloneMap),
        classDetailsArtifactSlug: (0, cloneUtils_1.getClonedArtifactSlug)(classDetailsArtifactSlug, cloneMap),
        fundingSubmissionComponentsArtifactSlug: (0, cloneUtils_1.getClonedArtifactSlug)(fundingSubmissionComponentsArtifactSlug, cloneMap),
        cashResponseTapeArtifactSlug: (0, cloneUtils_1.getClonedArtifactSlug)(cashResponseTapeArtifactSlug, cloneMap),
    };
};
const cloneFromTemplateArtifact = ({ artifactToClone, newArtifactDocumentId, cloneMap, }) => {
    const configuration = cloneConfig({
        config: artifactToClone.configuration,
        cloneMap,
    });
    return {
        artifactSlug: (0, cloneUtils_1.getClonedArtifactSlug)(artifactToClone.artifactSlug, cloneMap),
        artifactDocumentId: newArtifactDocumentId,
        creditFacilitySlug: (0, cloneUtils_1.getClonedSlug)(artifactToClone.creditFacilitySlug, cloneMap),
        loanProductSlug: (0, cloneUtils_1.getClonedSlug)(artifactToClone.loanProductSlug, cloneMap),
        externalFilename: null,
        id: (0, uuid_1.v4)(),
        type: node_1.artifactType,
        configuration,
    };
};
exports.cloneFromTemplateArtifact = cloneFromTemplateArtifact;
//# sourceMappingURL=clone.js.map